<template>
    <v-empty-state
      headline="Oh no, 404"
      :title="$t('404.title')"
      :text="$t('404.text')"
      size="350"  
      :image="currentImage"
      :action-text="$t('404.action')"
      @click:action="goToHomePage"
    ></v-empty-state>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref } from 'vue';

const router = useRouter()
const goToHomePage = () => router.push('/')

// základ URL ke statikám (přizpůsob si)
const staticBase = (process.env.VUE_APP_API_STATIC_URL || '') + 'static/'

// definuj názvy souborů
const imageNames = ['404_1.jpg', '404_2.jpg', '404_3.jpg', '404_4.jpg']

// vyber náhodný při načtení
const currentImage = ref(staticBase + imageNames[Math.floor(Math.random() * imageNames.length)])
</script>
